export const buildApiUrl = (path = '') => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  // Local dev points directly at the local Express server. Production uses
  // same-origin API routes, which the production reverse proxy forwards.
  const fallbackBase = process.env.NODE_ENV === 'development' ? 'http://localhost:4010' : '';
  const configuredBase = (process.env.REACT_APP_API_URL || fallbackBase).trim();

  return `${configuredBase.replace(/\/$/, '')}${normalizedPath}`;
};
